<template>
<div class="wl-certify-standard">
    <div class="wl-breadcrumb-trail">
        <div class="crumbs-text">
            <i class="wl-icon-zhuye1"></i>
            <span>当前位置：</span>
            <span @click="goHome">首页</span>
            <span>></span>
            <span>申请标准</span>
        </div>
    </div>
    <div class="wl-standard-content">
        <div class="standard-class-top">
            <h3 class="h3-standard-title">申请标准</h3>
            <div class="class-border"></div>
            <p class="p-certi-standards">CERTIFICATION STANDARDS</p>
        </div>
        <div class="wl-classif-ication clearfix">
            <div class="loy-border-back" v-for="(item,index) in list" :key="index" :style="{backgroundImage: 'url(' + (item.Cover || imgBack3) + ')'}">
                <div class="border-margin">
                    <div class="border-back" @click="goStandard('wly',item.Id)">
                        <p class="logistics-member">{{item.name}}</p>
                        <div class="p-border"></div>
                        <p class="standard-bottom">
                            <span v-if="item.NodeNames.length>0">{{item.NodeNames[0].Title || ""}}</span>
                            <span>|</span>
                            <span v-if="item.NodeNames.length>1">{{item.NodeNames[1].Title || ""}}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            imgBack1: require("assets/images/bg1.png"),
            imgBack2: require("assets/images/bg2.png"),
            imgBack3: require("assets/images/bg3.png"),
            imgBack4: require("assets/images/bg4.png"),
            list: []
        }
    },
    created() {
        this.getAuthentication();
    },
    computed: {
        association: function () {
            return this.$store.state.association;
        }
    },
    methods: {
        goHome() {
            this.$router.push({
                name: 'xHome'
            })
        },
        goStandard(isLevel, Id) {
            this.$router.push({
                name: 'standardDetail',
                params: {
                    isLevel: isLevel,
                    id: Id
                }
            })
        },
        getAuthentication() {
            var that = this;
            this.$http.post("/api/XOrg/AuthenticationShow/getAuthenticationList", {
                associationId: this.association.Id
            }).then(function (rst) {
                that.list = rst.authenticationList;
            })
        }
    }
}
</script>

<style>

</style>
